export default __webpack_public_path__ + "static/media/spark_78.e57754d8.png";